angular.module('env.custom.customModule.assetsRegister', ['common.directives.inView'])

    // Below is the route config and controller for the custom view 'Customers' for Footlink company
    .config(function ($stateProvider) {

        $stateProvider.state('client.assetsRegister', {
            url: '/assetsRegister',
            templateUrl: 'branding/footlink/assetsRegister/assetsRegister.html',
            controller: 'AssetsRegisterController',

            data: {pageTitle: 'OrderManager: Assets Register'}
        });
    })

    .controller('AssetsRegisterController', function AssetsRegisterController($q,
                                                                              $log,
                                                                              $scope,
                                                                              $state,
                                                                              toastr,
                                                                              gettextCatalog,
                                                                              usersRepository,
                                                                              ordersRepository,
                                                                              orderItemsRepository,
                                                                              $timeout,
                                                                              customResourceResolver,
                                                                              $customisationConfig,
                                                                              permissions,
                                                                              uiLocalization,
                                                                              intuneService) {

        $scope.isBusy = true;
        $scope.limit = 10; // initial value for limit
        $scope.tableHeaderLabel = '';
        $scope.tooOldVersionDetected = false;
        $scope.todayDate = new Date();

        $scope.iOSScanAppLatestVersion = '1.5.5.2';
        $scope.winScanAppLatestVersion = '1.5.1.0';

        var assetTypes = [
            {
                text: gettextCatalog.getString("All Devices"),
                value: {deviceType: 'All', deviceId: ''}
            },
            {
                text: gettextCatalog.getString("iQube Devices"),
                value: {deviceType: 'Windows', deviceId: ''}
            },
            {
                text: gettextCatalog.getString("iPad Devices"),
                value: {deviceType: 'IOS', deviceId: ''}
            }
        ];

        $scope.$on("$destroy", function () {
        });

        $scope.tableHeaderLabel = gettextCatalog.getString("ORTESI OWNED ASSET REGISTER - ") + assetTypes[0].text;
        $scope.assetType = assetTypes[0].value;

        $scope.loadMore = function (last, inview) {
            if (last && inview) {
                $scope.limit += 20;
            }
        };

        $scope.doPrint = function () {
            $scope.limit = 10000000;
            //A little trick to call requestAnimationFrame twice to make sure the DOM
            //has been updated to render all the TABLE rows and cells after we change the limit for it
            //Once the DOM update finishes, we raise the printing dialog
            var intermediate = function () {
                window.requestAnimationFrame(function () {
                    window.print();
                });
            };
            window.requestAnimationFrame(intermediate);
        };

        $scope.userSearch = function (item) {
            if (!$scope.userFilter ||
                (item.$model.name &&
                    item.$model.name.toLowerCase().indexOf($scope.userFilter.toLowerCase()) !== -1) ||
                (item.lastOrder && item.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.MachineName &&
                    item.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.MachineName.toLowerCase().indexOf($scope.userFilter.toLowerCase()) !== -1) ||
                (item.lastOrder && item.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.MachineSerialNumber &&
                    item.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.MachineSerialNumber.toLowerCase().indexOf($scope.userFilter.toLowerCase()) !== -1) ||
                (item.lastOrder && item.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.ApplicationVersion &&
                    item.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.ApplicationVersion.toLowerCase().indexOf($scope.userFilter.toLowerCase()) !== -1) ||
                (item.$model.customFields.Class &&
                    item.$model.customFields.Class.toLowerCase().indexOf($scope.userFilter.toLowerCase()) !== -1)) {
                return true;
            }
            return false;
        };

        $scope.usersDevicesSort = function (user) {
            if (user && user.device && user.device.deviceName) {
                return user.device.deviceName;
            }
            if (user && user.lastOrder && user.lastOrder.$model && user.lastOrder.$model.jsonData && user.lastOrder.$model.jsonData.OrderData && user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData) {
                return user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.MachineName;
            }
            return 'n/a';
        };

        initData();

        function initDeviceTypesDropDown() {

            if ($scope.users) {
                var groupsCount = _.countBy($scope.users, function (u) {
                    if (u.$model.customFields.Class === 'iPad') {
                        return 'iPad';
                    } else if (u.$model.customFields.Class.indexOf('Waiting') !== -1) {
                        return 'Waiting';
                    } else if (u.$model.customFields.Class.startsWith('iQube')) {
                        return 'iQube';
                    }
                });
                //if we have users collection initialised, update asset types dropdown with counts
                _.forEach(assetTypes, function (assetType) {
                    switch (assetType.value.deviceType) {
                        case "All":
                            assetType.text += _.str.sprintf(' (%s)', $scope.users.length); //show all users count
                            break;
                        case "IOS":
                            assetType.text += _.str.sprintf(' (%s)', groupsCount.iPad); //show ipad users count
                            break;
                        case "Windows":
                            assetType.text += _.str.sprintf(' (%s)', groupsCount.iQube); //show iqube users count
                            break;
                    }
                });

            }

            $scope.dropdownAssetsTypesOptions = {
                dataSource: assetTypes,
                dataTextField: "text",
                dataValueField: "value",
                valueTemplate: '',
                template: "<span class='k-state-default'><span>{{dataItem.text|sTranslate}}</span></span>",
                select: function (e) {
                    var selectedItem = $scope.dropdownAssetsTypesOptions.dataSource[e.item.index()];
                    if ($scope.assetType !== selectedItem.value) {
                        $scope.tableHeaderLabel = gettextCatalog.getString("ORTESI OWNED ASSET REGISTER - ") + selectedItem.text;
                        $scope.isBusy = true;
                        $scope.users = null;
                        $scope.assetType = selectedItem.value;
                        initData();
                    }
                },
                dataBound: function () {
                    this.list.width('auto');
                }
            };
        }

        function initData() {

            $scope.limit = 10;

            var initDataPromise = usersRepository.search(queryForUsersSet($scope.assetType.deviceType))
                .then(function (usersSet) {
                    //Get users list from OM
                    $scope.usersCount = usersSet.items.length;
                    $scope.users = usersSet.items; //after all we will assemble a list of entities here that will
                                                   //represent user/device with its metadata.
                                                   //If we will have a managed device w/o assigned user, we will add
                                                   //entity here with the device serial, w/o user.$model
                    initDeviceTypesDropDown();

                    //Get managed devices information from MDM via request to OM
                    return intuneService.getManagedDevices().then(function (devices) {
                        $scope.managedDevices = devices;
                    });
                })
                .then(function () {
                    //Create promise for each user object that will fetch order/orderitem info from OM for that user containing
                    //more metadata information about the device this user is using
                    var ordersPromises = [];
                    _.each($scope.users,
                        function (u) {
                            //if it's a real user model
                            if (u && u.$model) {
                                ordersPromises.push(orderItemsRepository
                                    .search({
                                        where: "OrderItem.Deleted = false AND CreatedBy.Name = '" + u.$model.name +
                                            "' AND (Step.Code <> 'Cancelled' OR Step.Code = 'Cancelled')", //To include all open/completed orders and cancelled as well.
                                        orderBy: 'OrderItem.Created desc',
                                        pageNumber: 0,
                                        rowsPerPage: 3 //to try and include not only 'second' orders as they may contain outdated device info but we can't filter them out with omql
                                    }, true)
                                    .then(function (result) {
                                        var user;
                                        if (result && result.items && result.items.length > 0) {
                                            //Look through each order item in the list, returning the first one that belongs to non-second order
                                            var latestNonSecondOrderItem = _.find(result.items, function (oi) {
                                                return !oi.$model.order.$model.customFields.IsSecond;
                                            });
                                            if (!latestNonSecondOrderItem) {
                                                //if there are no non-second orders amongst returned orders, just use the latest one
                                                latestNonSecondOrderItem = result.items[0];
                                            }
                                            //And assign the found latest order onto the user
                                            user = _.find($scope.users, function (o) {
                                                return o.$model.name === latestNonSecondOrderItem.$model.createdBy;
                                            });
                                            user.lastOrder = latestNonSecondOrderItem.$model.order;
                                        }
                                        //By some reason we need to explictly check the user like the check below
                                        if (!user) {
                                            $scope.tooOldVersionDetected = true;
                                        } else if ($scope.criticalVersionUser(user)) {
                                            $scope.tooOldVersionDetected = true;
                                        }
                                    }));
                            }
                        });
                    return $q.all(ordersPromises);
                })
                .then(function () {
                    //Process the collections to form the final collection representing devices and users
                    _.each($scope.managedDevices, function (managedDevice) {
                        var assignedUser = _.find($scope.users, function (u) {
                            var isSameSerial = u.lastOrder && u.lastOrder.$model.jsonData && u.lastOrder.$model.jsonData.OrderData && u.lastOrder.$model.jsonData.OrderData.ApplicationOrderData &&
                                u.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.MachineSerialNumber === managedDevice.serialNumber;
                            var isSameMachineName = u.lastOrder && u.lastOrder.$model.jsonData && u.lastOrder.$model.jsonData.OrderData && u.lastOrder.$model.jsonData.OrderData.ApplicationOrderData &&
                                u.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.MachineName === managedDevice.deviceName;

                            return isSameSerial && isSameMachineName;
                        });
                        if (assignedUser) {
                            //otherwise just store device on a user just in case
                            assignedUser.device = managedDevice;
                        } else {
                            //we have a managed device w/o assigned user, but we need to show it, so add a fake record
                            //however we need to make sure the OS of the managed in Intune (MDM) device is the same as the OS 
                            //of the selected device type in the dropdown
                            if ($scope.assetType.deviceType.toLowerCase() === managedDevice.operatingSystem.toLowerCase() ||
                                $scope.assetType.deviceType.toLowerCase() === 'all') {
                                $scope.users.push({ device: managedDevice });
                            }
                        }
                    });
                })
                .then(function () {
                    $scope.isBusy = false;
                })
                .catch(function (resp) {
                    initDataPromise = null;
                    if (resp && resp.status) {
                        toastr.error(uiLocalization.translate("Data request failed. Error %s : %s", resp.status, resp.statusText));
                    } else {
                        toastr.error(gettextCatalog.getString("Data request failed"), gettextCatalog.getString("Server is not responding"));
                    }
                });

            return initDataPromise;
        }

        function queryForUsersSet(deviceType) {
            var query =
                "User.Name <> 'DownloadService' AND User.Name <> 'admin' AND User.Name <> 'LabUser' AND User.Name <> 'appletest' AND " +
                "User.Name <> 'comlaw' AND User.Name <> 'DelcamSupport' AND User.Name <> 'ortesi2' AND User.Name <> 'Test' AND User.Disabled = false";

            if (deviceType && deviceType.length > 0) {
                switch (deviceType) {
                    case "IOS":
                        query += " AND User.Class = 'iPad'";
                        break;
                    case "Windows":
                        query += " AND User.Class NOT LIKE '%Waiting' AND User.Class LIKE 'iQube%'";
                        break;
                    case "All":
                        query += " AND User.Class NOT LIKE '%Waiting' AND (User.Class = 'iPad' OR User.Class LIKE 'iQube%')";
                        break;
                    default:
                        break;
                }
            }

            //Filtering out the users who are own their devices
            //We user user's customfield DeviceId for that.
            query += " AND User.DeviceId <> 'Own' AND User.DeviceId NOT LIKE '%CLINIC OWNED%'";


            return {
                where: query,
                orderBy: "",
                pageNumber: 0,
                rowsPerPage: 100000000
            };
        }

        $scope.isZeroOrdersUser = function (user) {
            return !user.lastOrder;
        };

        $scope.isTooOldVersionUser = function (user) {
            return !user.lastOrder ||
                !user.lastOrder.$model.jsonData ||
                !user.lastOrder.$model.jsonData.OrderData ||
                !user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData ||
                !user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.ApplicationVersion;
        };

        $scope.criticalVersionUser = function (user) {
            return $scope.isZeroOrdersUser(user) || $scope.isTooOldVersionUser(user);
        }

        $scope.warnVersionUser = function (user) {
            if ($scope.criticalVersionUser(user)) {
                return false;
            }
            if (!user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.Platform) {
                //If we have no platform info - the version is definitely not the latest
                return true;
            }
            if (user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.Platform === 'IOS') {
                return user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.ApplicationVersion !== $scope.iOSScanAppLatestVersion;
            }
            if (user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.Platform === 'Windows') {
                return user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.ApplicationVersion !== $scope.winScanAppLatestVersion;
            }

            //or just warn by default if no version info
            return !user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.ApplicationVersion;
        }

        // Map region ------------------------------------------------------------------

        $scope.initMap = function (deviceLocation, userName, machineName, machineSerial) {
            $scope.mapOptions = {
                zoom: 10,
                center: new google.maps.LatLng(deviceLocation.Lat, deviceLocation.Lng)
            };
            if (angular.isUndefined($scope.map)) {
                $scope.map = new google.maps.Map(document.getElementById('gmap'));
            }
            if (angular.isUndefined($scope.markerInfo)) {
                $scope.markerInfo = new google.maps.InfoWindow();
            }

            if (!angular.isUndefined($scope.deviceMarker)) {
                $scope.deviceMarker.setMap(null);
                $scope.deviceMarker = null;
            }

            $scope.map.setOptions($scope.mapOptions);

            $scope.deviceMarker = new google.maps.Marker({
                map: $scope.map,
                position: new google.maps.LatLng(deviceLocation.Lat, deviceLocation.Lng),
                title: _.str.sprintf("%s (%s)", machineName, userName),
                content: _.str.sprintf('<div><b>Latitude:</b> %s</div><div><b>Longitude:</b> %s</div><div><b>Device Serial:</b> %s</div>',
                    deviceLocation.Lat, deviceLocation.Lng, machineSerial)
            });

            google.maps.event.addListener($scope.deviceMarker, 'click', function () {
                $scope.markerInfo.setContent(_.str.sprintf('<div><b>%s</b> (%s)</div><p>%s</p>', machineName, userName, $scope.deviceMarker.content));
                $scope.markerInfo.open($scope.map, $scope.deviceMarker);
            });
        }

        $scope.loadMapScript = function () {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCKfTb9mUPiJBfgbRhZMFh8etPQGt-cWc4&extension=.js';
            document.body.appendChild(script);
        }

        $scope.mapWindowWidth = 800;
        $scope.viewDeviceLocation = function (deviceLocation, user) {

            $scope.deviceLocationWindow.setOptions({
                title: _.str.sprintf("%s (%s) location", user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.MachineName, user.$model.name),
                position: {
                    top: '15%',
                    left: (jQuery(window).width() - $scope.mapWindowWidth) / 2
                },
                animation: om.config.kendoWindowDefaultOptions.animation
            });

            $scope.initMap(
                deviceLocation,
                user.$model.name,
                user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.MachineName,
                user.lastOrder.$model.jsonData.OrderData.ApplicationOrderData.MachineSerialNumber);

            $scope.deviceLocationWindow.open();
        };

        // End of Map region -----------------------------------------------------------
    })

;
